module.exports = {"220822100":"开通镇","220822101":"瞻榆镇","220822102":"双岗镇","220822103":"兴隆山镇","220822104":"边昭镇","220822105":"鸿兴镇","220822106":"新华镇","220822107":"乌兰花镇","220822200":"新发乡","220822201":"新兴乡","220822202":"向海蒙古族乡","220822203":"包拉温都蒙古族乡","220822204":"团结乡","220822205":"十花道乡","220822206":"八面乡","220822207":"苏公坨乡","220822400":"通榆经济开发区","220822401":"三家子种牛场","220822402":"良井子畜牧场","220822403":"双岗鹿场","220822404":"同发牧场","220822405":"新华牛场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/220822.json
// module id = 660
// module chunks = 0